module.exports = __webpack_public_path__ + "static/img/loginL.5eb372f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/loginL.png
// module id = ZICZ
// module chunks = 18